module.exports = __webpack_public_path__ + "static/media/TrawloBanner2.0.938097f2.png";